module.exports = __webpack_public_path__ + "static/media/aboutus.8d02d0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutus.jpg
// module id = 383
// module chunks = 0